import LyMonthRange from './src/index.vue'

LyMonthRange.install = function (Vue) {
    Vue.component(LyMonthRange.name, LyMonthRange)
}

export default LyMonthRange



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/month-range/index.js
// module id = null
// module chunks = 